import { Howl } from 'howler';
import { trace } from 'rytm-helpers';

const SOUND_BG_FADE_IN_TIME = 10000;
const SOUND_FADE_OUT_TIME = 800;
let soundsBg = [];
let soundsAccent = [];
let analyserL = null;
let analyserR = null;


export const playAccentSound = (params) => {
  // trace("# Accent:", params.src[0], params);
  const sound = new Howl(params);
  sound.soundId = params.soundId ? params.soundId : Date.now() + Math.floor(Math.random() * 1000);
  sound.on('play', () => {
    if (params.onPlay) params.onPlay();
  });
  sound.on('end', () => {
    removeAccentSound(sound);
    if (params.onComplete) params.onComplete();
  });
  sound.play();
  sound.fade(0, params.volume, SOUND_BG_FADE_IN_TIME);
  soundsAccent.push(sound);
}
const getAccentSound = (soundId)  => {
  return soundsAccent.find(sound => sound.soundId === soundId);
}
export const playBgSounds = (paramsList) => {
  paramsList.forEach(playBgSound);  
}
const playBgSound = (params) => {
  // trace("# BG:", params.src[0], params);
  const sound = new Howl(params);
  sound.soundId = Date.now() + Math.floor(Math.random() * 1000);
  sound.on('end', () => {
    removeAccentSound(sound);
  });
  sound.play();
  sound.fade(0, params.volume, SOUND_BG_FADE_IN_TIME);
  soundsBg.push(sound);
}
export const fadeOutSounds = (time = SOUND_FADE_OUT_TIME) => {
  fadeOutBgSounds(time);
  fadeOutAccentSounds(time);
}
export const stopAllSounds = () => {
  stopBgSounds();
  stopAccentSounds();
}
export const fadeOutBgSounds = (time = SOUND_FADE_OUT_TIME) => {
  soundsBg.forEach((sound) => {
    sound.fade(sound.volume(), 0, time)
    setTimeout(() => {
      sound.stop();
      removeBgSound(sound);
      sound.unload();
    }, time);
  });
}
export const fadeOutAccentSounds = (time = SOUND_FADE_OUT_TIME) => {
  soundsAccent.forEach((sound) => {
    sound.fade(sound.volume(), 0, time);
    setTimeout(() => {
      sound.stop();
      removeAccentSound(sound);
      sound.unload();
    }, time);
  });
}
const stopBgSounds = () => {
  soundsBg.forEach((sound) => {
    sound.stop();
    removeBgSound(sound);
    sound.unload();
  });
}
const stopAccentSounds = () => {
  soundsAccent.forEach((sound) => {
    sound.stop();
    removeAccentSound(sound);
    sound.unload();
  });
}
const removeBgSound = (sound) => {
  soundsBg = soundsBg.filter(snd => snd.soundId !== sound.soundId);
  // trace("remove BG sound, length:", soundsBg.length);
}
const removeAccentSound = (sound) => {
  soundsAccent = soundsAccent.filter(snd => snd.soundId !== sound.soundId);
  // trace("remove ACCENT sound, length:", soundsAccent.length);
}
// get audio analyser for accent sound (by ID)
export const getAccentSoundAnalyserData = (soundId) => {
  let data = {};
  const sound = getAccentSound(soundId);
  return {
    ...data,
    gain: sound?._sounds[0]?._node?.gain?.value,
    currentTime: sound ? sound.seek() : null,
    duration: sound ? sound.duration() : null,
  }
}



// #### Depeciated - but helpful for future reference ####
// get audio analyser - two channels volume data 
export const getAudioAnalyserData = () => {
  if (!analyserL || !analyserR) {
    // create analyser for stereo field
    const splitter = Howler.ctx ? Howler.ctx.createChannelSplitter(2) : null;
    if (splitter) {
      analyserL = Howler.ctx.createAnalyser();
      analyserR = Howler.ctx.createAnalyser();
      Howler.masterGain.connect(splitter);
      splitter.connect(analyserL, 0, 0);
      splitter.connect(analyserR, 1, 0);
    }
  }
  // data array for frequency data LEFT channel
  const dataArrayFreqL = new Uint8Array(analyserL.frequencyBinCount);
  // data array for frequency data RIGHT channel
  const dataArrayFreqR = new Uint8Array(analyserR.frequencyBinCount);
  // get the current frequencies
  analyserL.getByteFrequencyData(dataArrayFreqL);
  analyserR.getByteFrequencyData(dataArrayFreqR);
  return {
    channels: [
      {
        name: "L",
        // dataArray: dataArrayFreqL,
        ...getAverageFrequencyParams(dataArrayFreqL),
      },
      {
        name: "R",
        // dataArray: dataArrayFreqR,
        ...getAverageFrequencyParams(dataArrayFreqR),
      },
    ]
    
  };
}
const getAverageFrequencyParams = (dataArray) => {
  let values = 0;
  const length = dataArray.length;
  // let valuesLow = 0;
  // let valuesMid = 0;
  // let valuesHigh = 0;
  // let lengthLow = 0;
  // let lengthMid = 0;
  // let lengthHigh = 0;
  // const lowEnd = Math.floor(length * .333);
  // const highStart = Math.floor(length * .666);
  for (let i = 0; i < length; i++) {
    values += dataArray[i];
    // if (i < lowEnd) {
    //   valuesLow += dataArray[i];
    //   lengthLow++;
    // } else if (i >= lowEnd && i < highStart) {
    //   valuesMid += dataArray[i];
    //   lengthMid++;
    // } else {
    //   valuesHigh += dataArray[i];
    //   lengthHigh++;
    // }
  }
  return {
    vol: values / length / 128,
    // volLow: valuesLow / lengthLow,
    // volMid: valuesMid / lengthMid,
    // volHigh: valuesHigh / lengthHigh,
  };
}